import parseLocale from '@/core/i18n/parse-locale';

/** Uniform Canvas / entries API language code when the app locale is missing or invalid. */
export const UNIFORM_API_LANGUAGE_FALLBACK = 'en';

/** BCP 47–style primary language subtag (e.g. en, nl, no). Rejects junk from bad `[locale]` matches (e.g. `.well` from `.well-known`). */
const UNIFORM_LANGUAGE_SUBTAG = /^[a-z]{2,8}$/;

/**
 * Maps an app locale string to the language segment sent to Uniform APIs.
 * Falls back to English when missing, reserved (`_next`), or not a valid language subtag.
 */
export function resolveUniformApiLanguage(locale: string): string {
  const { language } = parseLocale(locale);
  if (!language || !UNIFORM_LANGUAGE_SUBTAG.test(language)) {
    return UNIFORM_API_LANGUAGE_FALLBACK;
  }
  return language;
}

/**
 * Same as {@link resolveUniformApiLanguage}, but preserves "no locale filter" when
 * the caller omits `locale` (used by entry list fetches).
 */
export function resolveUniformApiLanguageOptional(
  locale: string | undefined,
): string | undefined {
  if (locale === undefined) return undefined;
  return resolveUniformApiLanguage(locale);
}
